module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Order #{id}":"Order #{id}","Category #{id}":"Category #{id}","Category \\\\#{id}":"Category \\\\#{id}","Order \\\\#{id}":"Order \\\\#{id}"},"de":{"Order #{id}":"Bestellung #{id}","Category #{id}":"Kategorie #{id}","being calculated":"wird berechnet"}}')
  delete Component.options._Ctor
}
